module.exports = __webpack_public_path__ + "images/e2b04b66e12e54f45a154d038a89e0eff6a477e88918d404af68f936c7fe4218.svg";